import { Card, message, Modal } from "antd";
import React, { useState } from "react";
import useAxios from "../../hooks/useAxios";

const VoiceBotDetails = ({ candidate, isAdmin, setLoad, loadCandidate, canEditAdditionalInfo }) => {
  const [openModal, setOpenModal] = useState(false);
  const api = useAxios();
  const [inputData, setInputData] = useState({
    packageConfirmation: candidate?.voiceBotData?.Package_Confirmation || "",
    Broadband_and_System_availability:
      candidate?.voiceBotData?.Broadband_and_System_availability || "",
    interest: candidate?.voiceBotData?.Interest || "",
    positionAppliedFor: candidate?.voiceBotData?.Position_Applied_For || "",
    wfh_preferred_location:
      candidate?.voiceBotData?.wfh_preferred_location || "",
    diploma_holder: candidate?.voiceBotData?.diploma_holder || "",
    rotational: candidate?.voiceBotData?.rotational || "",
  });

  const updateData = async () => {
    try {
      setLoad(true);
      const { data } = await api.put(
        `/voiceBot/${candidate?.voiceBotData?._id}`,
        inputData,
        {
          tokenType: "user",
        }
      );
      if (data) {
        await loadCandidate();
        setOpenModal(false);
        message.success("Details updated successfully.");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      <Card className="border mb-4 bg-white" title="Additional Information">
        <div className=" p-0">
          <table className="table bg-white respons-table">
            <tbody>
              <tr>
                <th>Package Confirmation</th>
                <td>{candidate?.voiceBotData?.Package_Confirmation}</td>
              </tr>
              <tr>
                <th>Broadband & System Availability</th>
                <td>
                  {candidate?.voiceBotData?.Broadband_and_System_availability}
                </td>
              </tr>
              <tr>
                <th>Interest</th>
                <td>{candidate?.voiceBotData?.Interest}</td>
              </tr>
              <tr>
                <th>Position Applied For</th>
                <td>{candidate?.voiceBotData?.Position_Applied_For}</td>
              </tr>
              <tr>
                <th>WFH Preferred Location</th>
                <td>{candidate?.voiceBotData?.wfh_preferred_location}</td>
              </tr>
              <tr>
                <th>Diploma Holder</th>
                <td>{candidate?.voiceBotData?.diploma_holder}</td>
              </tr>
              <tr>
                <th>Rotational</th>
                <td>{candidate?.voiceBotData?.rotational}</td>
              </tr>
            </tbody>
          </table>
          {!candidate.IsSelected && candidate?.form && (
            <>
              {candidate.responses.length !== 0
                ?  canEditAdditionalInfo && (
                    <button
                      className={`btn btn-sm ${
                        !candidate?.isEmpTempIdCreated
                          ? "btn-primary"
                          : "btn-secondary"
                      } btn-table-control mx-1`}
                      onClick={() => setOpenModal(true)}
                      disabled={candidate?.isEmpTempIdCreated}
                    >
                      Edit
                    </button>
                  )
                : canEditAdditionalInfo && (
                    <button
                      disabled={
                        (candidate?.L3_Status === "Selected" &&
                          candidate?.trf?.trfType === "Sampark") ||
                        (candidate?.L4_Status === "Selected" &&
                          candidate?.trf?.trfType === "Sampark")
                          ? true
                          : false
                      }
                      className="btn btn-sm btn-primary btn-table-control mx-1"
                      onClick={() => setOpenModal(true)}
                    >
                      Edit
                    </button>
                  )}
            </>
          )}
        </div>
      </Card>
      <Modal
        centered
        open={openModal}
        onOk={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
        footer={false}
        zIndex={9}
        width={1000}
      >
        <div>
          <div className="col-md-12">
            <Card title="Update Additional Information" className="border mt-3">
              <div className="mt-2">
                <label htmlFor="">Package Confirmation</label>
                <input
                  type="text"
                  className="border form-control"
                  placeholder=""
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      packageConfirmation: e.target.value,
                    })
                  }
                  value={inputData?.packageConfirmation}
                />
              </div>
              <div className="mt-2">
                <label htmlFor="">Broadband & System Availability</label>
                <input
                  type="text"
                  className="border form-control"
                  placeholder=""
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      Broadband_and_System_availability: e.target.value,
                    })
                  }
                  value={inputData?.Broadband_and_System_availability}
                />
              </div>
              <div className="mt-2">
                <label htmlFor="">Interest</label>
                <input
                  type="text"
                  className="border form-control"
                  placeholder=""
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      interest: e.target.value,
                    })
                  }
                  value={inputData?.interest}
                />
              </div>
              <div className="mt-2">
                <label htmlFor="">Position Applied For</label>
                <input
                  type="text"
                  className="border form-control"
                  placeholder=""
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      positionAppliedFor: e.target.value,
                    })
                  }
                  value={inputData?.positionAppliedFor}
                />
              </div>
              <div className="mt-2">
                <label htmlFor="">WFH Preferred Location</label>
                <input
                  type="text"
                  className="border form-control"
                  placeholder=""
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      wfh_preferred_location: e.target.value,
                    })
                  }
                  value={inputData?.wfh_preferred_location}
                />
              </div>
              <div className="mt-2">
                <label htmlFor="">Diploma Holder</label>
                <input
                  type="text"
                  className="border form-control"
                  placeholder=""
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      diploma_holder: e.target.value,
                    })
                  }
                  value={inputData?.diploma_holder}
                />
              </div>
              <div className="mt-2">
                <label htmlFor="">Rotational</label>
                <input
                  type="text"
                  className="border form-control"
                  placeholder=""
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      rotational: e.target.value,
                    })
                  }
                  value={inputData?.rotational}
                />
              </div>
              <div className="text-center">
                <button
                  className={`btn mt-4 ${"btn-primary"}`}
                  type="submit"
                  onClick={updateData}
                >
                  Update
                </button>
              </div>
            </Card>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default VoiceBotDetails;
